let _scrollHeightY;
let _isDisabled = false;

function disableScrolling() {
  if (_isDisabled) return;
  _isDisabled = true;
  _scrollHeightY = window.scrollY;
  document.body.setAttribute('data-scroll-disabled', '');
  document.body.style.setProperty('position', 'fixed');
  document.body.style.setProperty('overflow', 'hidden');
  document.body.style.setProperty('top', `-${_scrollHeightY}px`);
}

function enableScrolling() {
  if (!_isDisabled) return;
  document.body.style.removeProperty('position');
  document.body.style.removeProperty('top');
  document.body.style.removeProperty('overflow');
  window.scrollTo({ top: _scrollHeightY, left: 0 });
  setTimeout(() => {
    document.body.removeAttribute('data-scroll-disabled');
  }, 10);
  _isDisabled = false;
}

export { disableScrolling, enableScrolling };
